import { type FieldError } from 'react-hook-form';
import isPlainObject from 'lodash.isplainobject';

import { preferedItemsModeKey } from '../constants';

export const licenseDataToOptionsList = (
  data: {
    licenseTypeCode: string;
    licenseTypeName: string;
    id: number;
  }[] = [],
  withTag = true,
  useCodeAsLabel = false
): SelectOption[] =>
  data.map(({ licenseTypeCode, licenseTypeName, id }) =>
    withTag
      ? {
          label: useCodeAsLabel ? licenseTypeCode : licenseTypeName,
          value: licenseTypeCode,
          tag: {
            label: useCodeAsLabel ? licenseTypeName : licenseTypeCode,
          },
          id,
        }
      : {
          label: useCodeAsLabel ? licenseTypeCode : licenseTypeName,
          value: licenseTypeCode,
          id,
        }
  );

export interface IGetInputPropsArgs {
  isViewMode?: boolean;
  isSubmitting?: boolean;
  isDisabled?: boolean;
  value?: any;
  error?: FieldError;
}

export const getInputProps = (
  { isViewMode, isSubmitting, isDisabled, value, error }: IGetInputPropsArgs,
  isCheckBox?: boolean
) => {
  const inputProps = {
    value: value ?? '',
    valueView: value === 0 ? value : value || '-',
    disabled: isDisabled || isSubmitting,
    viewMode: isViewMode,
    hasError: !isDisabled && !!error,
    errorMessage: !isDisabled ? error?.message : undefined,
  };

  if (isPlainObject(value)) {
    inputProps.valueView = undefined;
  }

  if (isCheckBox) {
    delete inputProps.valueView;
    delete inputProps.viewMode;
    delete inputProps.errorMessage;
    // @ts-expect-error
    delete inputProps.hasError;
    inputProps.value = Boolean(value);
    inputProps.disabled = isDisabled || isSubmitting || isViewMode;
  }

  return inputProps;
};

export function getPreferedItemsModeKey(username: string) {
  return `${username}::${preferedItemsModeKey}`;
}
